<template>
  <div class="app-container">
    <el-container>
      <el-aside width="400px" class="cbox-p14">
        <div class="section-header">部门列表</div>
        <div class="search-box">
          <el-input v-model.trim="filterText" placeholder="输入关键词进行筛选" prefix-icon="el-icon-search" clearable></el-input>
        </div>
        <div class="button-box">
          <el-button v-auth="'department:edit'" type="primary" @click="handleAddOrigin">新增</el-button>
          <el-button v-auth="'department:edit'" type="primary" plain @click="handleAddChildren">新增下级部门</el-button>
          <el-button v-auth="'department:delete'" type="danger" @click="handleDelete">删除</el-button>
        </div>
        <div class="tree-box">
          <el-tree
            ref="tree"
            :data="treeData"
            :current-node-key="currentNodeId"
            node-key="id"
            highlight-current
            default-expand-all
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            @node-click="handleTreeNode"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </el-aside>

      <el-main class="cbox-p14">
        <div class="section-header">部门信息</div>
        <el-form
          v-show="this.editForm.levelCode"
          :disabled="!isEdit"
          ref="editForm"
          class="dashed-border"
          v-loading="infoLoading"
          :model="editForm"
          :rules="rules"
          label-width="120px"
        >
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="24">
              <el-form-item label="上级部门" prop="parentName">
                <el-input v-model.trim="editForm.parentName" placeholder="请输入" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="部门名称" prop="name">
                <el-input v-model.trim="editForm.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编码" prop="code">
                <el-input v-model.trim="editForm.code" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="层级编码" prop="levelCode">
                <el-input v-model.trim="editForm.levelCode" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="机构类型" prop="orgType">
                <el-radio-group v-model="editForm.orgType" size="medium">
                  <el-radio-button label="0">集团</el-radio-button>
                  <el-radio-button label="1">公司</el-radio-button>
                  <el-radio-button label="2">部门</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否可用" prop="deleted">
                <el-switch
                  v-model="editForm.deleted"
                  :active-value="0"
                  :inactive-value="1"
                  active-text="启用"
                  inactive-text="禁用"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="textarea">
                <el-input type="textarea" v-model="editForm.textarea" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="this.editForm.levelCode" class="form-buttons">
          <template v-if="isEdit">
            <el-button @click="handleCancel">取消</el-button>
            <el-button :loading="saveLoading" type="primary" @click="handleSave">保存</el-button>
          </template>

          <el-button v-auth="'department:edit'" v-else type="primary" @click="isEdit = !isEdit">编辑</el-button>
        </div>

        <el-empty v-if="!this.editForm.levelCode" description="请选择部门信息"></el-empty>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { getOrgData, getOrg, saveOrg, deleteOrg } from '@/api/user';

import { getNextCode } from '@/utils/index';

export default {
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'nodes',
        label: 'text'
      },
      treeData: [],
      infoLoading: false,
      currentTreeNode: null,
      currentNodeId: null,
      editForm: {
        deleted: 0,
        orgType: 2
      },
      rules: {
        parentName: [{ required: true, message: '请输入上级', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        orgType: [{ required: true, message: '请选择机构类型', trigger: 'change' }]
      },
      isEdit: false,
      saveLoading: false
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    async getOrgData() {
      const data = await getOrgData();
      this.treeData = data;
    },
    async getOrg(id) {
      this.infoLoading = true;
      try {
        const data = await getOrg(id);
        this.editForm = {
          id: data.id,
          parentId: data.parentId,
          parentName: data.parentName,
          name: data.name,
          code: data.code,
          levelCode: data.levelCode,
          orgType: data.orgType,
          deleted: data.deleted
        };
      } finally {
        this.infoLoading = false;
      }
    },
    handleTreeNode(nodeData) {
      this.isEdit = false;
      this.currentTreeNode = nodeData;
      const id = nodeData.id;
      this.currentNodeId = id;
      this.getOrg(id);
    },
    resetTreeNode() {
      this.currentTreeNode = null;
      this.currentNodeId = null;
      this.handleReset();
      this.getOrgData();
    },
    handleAddOrigin() {
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        const lastCode = this.treeData?.[this.treeData.length - 1]?.levelCode ?? null;
        let levelCode = getNextCode('', lastCode, 6);
        this.editForm = { ...this.editForm, levelCode };
        this.isEdit = true;
        this.infoLoading = false;
      });
    },
    handleAddChildren() {
      const currentNode = this.currentTreeNode;
      if (!currentNode?.id) return this.$message.warning('请先选择要操作的上级部门！');
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        let lastCode = currentNode.nodes ? currentNode.nodes[currentNode.nodes.length - 1].levelCode : null;
        let levelCode = getNextCode(this.currentTreeNode.levelCode, lastCode, 6);
        this.editForm = { ...this.editForm, parentId: this.currentTreeNode.id, parentName: this.currentTreeNode.text, levelCode };
        this.isEdit = true;
        this.infoLoading = false;
      });
    },
    handleReset() {
      this.$refs.editForm.resetFields();
      this.editForm = {
        deleted: 0,
        orgType: 2
      };
    },
    handleCancel() {
      this.isEdit = !this.isEdit;
      if (this.currentNodeId) return this.getOrg(this.currentNodeId);
      this.handleReset();
    },
    handleSave() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.saveLoading = true;
          try {
            await saveOrg(this.editForm);
            this.$message.success('保存成功!');
            this.resetTreeNode();
          } finally {
            this.saveLoading = false;
          }
        }
      });
    },
    handleDelete() {
      const id = this.currentTreeNode?.id ?? null;
      if (!id) return this.$message.warning('请先选择要操作的部门！');
      if (this.currentTreeNode?.nodes?.length > 0) return this.$message.warning('该节点含有子部门，请先删除子部门！');

      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteOrg(id);
          this.resetTreeNode();
          this.$message.success('删除成功');
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.getOrgData();
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  overflow: visible;
}
.el-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  &.cbox-p14 {
    padding-top: 0;
  }

  .search-box {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 14px;
    }
  }
  .button-box {
    margin: 10px 0;
  }
  .tree-box {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.el-main {
  margin-left: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .dashed-border {
    flex: 1 1 auto;
    min-height: 0;
    padding: 14px 14px 0 0;
    margin-bottom: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .form-buttons {
    text-align: right;
  }
  .el-empty {
    height: 100%;
  }
  &.cbox-p14 {
    padding-top: 0;
  }
}

.section-header {
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
</style>
